import { combineReducers } from 'redux';
import authReducer from './authReducer';
import pointsReducer from './pointsReducer.js';
import creditsReducer from './creditsReducer.js';
import audioTranscriptionReducer from './audioTranscriptionReducer.js';
import organizationReducer from '../../features/organization/slice';

const rootReducer = combineReducers({
  auth: authReducer,
  points: pointsReducer,
  credits: creditsReducer,
  audioTranscription: audioTranscriptionReducer,
  organization: organizationReducer,
});

export default rootReducer;
